export default Object.freeze({
    COMPANY: {
        NOT_FOUND: 'COMPANY.NOT_FOUND',
        ALREADY_ACTIVE: 'COMPANY.ALREADY_ACTIVE',
        IS_IN_DEBT: 'COMPANY.IS_IN_DEBT',
    },
    USER: {
        NOT_FOUND: 'USER.NOT_FOUND',
    },
})
